import type * as React from "react";
import { cn } from "./utils";

// shadcn/ui Message (https://ui.shadcn.com/docs/components/base/message), ported to Tailwind 3.
// A row in a conversation or comment thread: avatar, then header, bubble and footer stacked in the content slot.

function MessageGroup({ className, ...props }: React.ComponentProps<"div">) {
    return <div data-slot="message-group" className={cn("flex flex-col gap-2 min-w-0", className)} {...props} />;
}

function Message({ className, align = "start", ...props }: React.ComponentProps<"div"> & { align?: "start" | "end" }) {
    return (
        <div
            data-slot="message"
            data-align={align}
            className={cn(
                "group/message relative flex gap-2 data-[align=end]:flex-row-reverse w-full min-w-0 text-sm",
                className
            )}
            {...props}
        />
    );
}

function MessageAvatar({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="message-avatar"
            className={cn(
                "flex justify-center items-center self-start bg-muted rounded-full w-fit min-w-8 overflow-hidden shrink-0",
                className
            )}
            {...props}
        />
    );
}

function MessageContent({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="message-content"
            className={cn(
                "flex flex-col gap-1.5 group-data-[align=end]/message:items-end w-full min-w-0 break-words",
                className
            )}
            {...props}
        />
    );
}

function MessageHeader({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="message-header"
            className={cn(
                "flex items-center gap-1.5 min-w-0 max-w-full font-medium text-muted-foreground text-xs",
                className
            )}
            {...props}
        />
    );
}

function MessageFooter({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="message-footer"
            className={cn(
                "flex items-center gap-1.5 group-data-[align=end]/message:justify-end min-w-0 max-w-full font-medium text-muted-foreground text-xs",
                className
            )}
            {...props}
        />
    );
}

export { MessageGroup, Message, MessageAvatar, MessageContent, MessageFooter, MessageHeader };
